 
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "sa-east-1",
    "aws_cognito_identity_pool_id": "sa-east-1:1e080fd1-9766-4cde-a04c-304b137c8c47",
    "aws_cognito_region": "sa-east-1",
    "aws_user_pools_id": "sa-east-1_L7FyfFFAB",
    "aws_user_pools_web_client_id": "58rnt2f34hfcqujtqrk076bn0j",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "krabo163508-dev",
    "aws_user_files_s3_bucket_region": "sa-east-1"
};


export default awsmobile;
